import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  editLotteryBrand,
  getAllLotteryBrands,
} from "../../../../redux/features/lotteryBrand/lotteryBrandService";
import styles from "./index.module.css";
import Skeleton from "../../../../components/Skeleton";
import NoResultsFound from "../../../../components/NoResultsFound";
import Modal from "../../../../components/Modal";
import { showToast } from "../../../../components/ToastMsg";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faPlus, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { faCircleXmark } from "@fortawesome/free-regular-svg-icons";

const LotteryBrands = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { isLotteriesLoading, lotteries } = useSelector(
    (state) => state.lottery.allLotteryBrands
  );

  const [isDeactivationModalOpen, setDeactivationModalOpen] = useState(false);
  const [selectedLotteryId, setSelectedLotteryId] = useState(null);
  const [selectedLotteryName, setSelectedLotteryName] = useState("");

  const closeDeactivationModal = () => setDeactivationModalOpen(false);

  const handleAddLottery = () => {
    navigate("create-new-lottery");
  };

  const handleEditLottery = (lotteryId) => {
    navigate(`edit-lottery/${lotteryId}`);
  };

  const fetchAllLotteries = useCallback(() => {
    dispatch(getAllLotteryBrands({}));
  }, [dispatch]);

  useEffect(() => {
    fetchAllLotteries();
  }, [fetchAllLotteries]);

  return (
    <div className={`card-section`}>
      <div className={`search-card`}>
        <div className={`search-card-header`}>
          <h1 className={`form-title ${styles.headDiv}`}>
            Lottery Brands
          </h1>
        </div>
        <div className={`search-card-body`}>
          {isLotteriesLoading ? (
            <Skeleton
              columns={["Image", "Code", "Name"]}
              rowCount={10}
              height={20}
            />
          ) : lotteries.length > 0 ? (
            <div className={`table-container`}>
              <table className={`table`}>
                <thead className={`thead`}>
                  <tr>
                    <th className={`theadColumnOne`}>Image</th>
                    <th>Code</th>
                    <th>Name</th>
                  </tr>
                </thead>
                <tbody className={`tbody`}>
                  {lotteries?.map((lottery) => (
                    <tr key={lottery.id}>
                      <td className={`tdataColumnOne`}>
                        {" "}
                        <img
                          src={lottery.logo_url}
                          alt={`${lottery.name} Logo`}
                          className={styles.lotteryImage}
                        />
                      </td>
                      <td>{lottery.code}</td>
                      <td>{lottery.name}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          ) : (
            <NoResultsFound />
          )}
        </div>
      </div>
    </div>
  );
};

export default LotteryBrands;
